import {useContext, useRef, useEffect} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import './HomePage.css';
// import illusion from '../assets/art8.png';
//import * as PIXI from 'pixi.js';
//import {ease} from 'pixi-ease';

export function HomePage()
{
	const h2 = Utils.tr('HOME_H2');
	const intro = Utils.tr('HOME_INTRO');
	const btnText = Utils.tr('HOME_BTN');
	const closure = useContext(AppContext);
	const pixiRef = useRef();

	const onClick = (e) =>
	{
		closure.dispatch({type: 'push', page: 'scene'});
	};

	// const onClick2 = (e) =>
	// {
	// 	closure.dispatch({type: 'pop'});
	// };
/*
	const emitter = closure.emitter;
	useEffect(() =>
	{
		const div = pixiRef.current;
		const pixi = new PIXI.Application({
			backgroundAlpha: 0,
			width: 600,
			height: 500
		});
		
		pixi.renderer.view.style.touchAction = 'auto';
		div.appendChild(pixi.view);

		const basePath = process.env.PUBLIC_URL + '/images/home/';
		let bundle = {
			b1: basePath + 'b1.png',
			y1: basePath + 'y1.png'
		};
		const bs = 9;
		let u = 1;
		for(; u <= bs; u++)
		{
			bundle['a' + u] = basePath + 'a' + u + '.png';
		}
		PIXI.Assets.addBundle('home', bundle);
		
		PIXI.Assets.loadBundle('home').then((res) =>
		{
			if(pixi.stage)
			{
				const cont = new PIXI.Container();
				const b1 = new PIXI.Sprite(res.b1);
				const y1 = new PIXI.Sprite(res.y1);
				const layer = new PIXI.Container();
				pixi.stage.addChild(cont);
				cont.addChild(b1);
				cont.addChild(layer);
				cont.addChild(y1);

				const b1P = {x: -5, y: -60};
				b1.position.set(pixi.renderer.width, b1P.y);

				const y1P = {x: pixi.renderer.width / 2 - 140, y: 80};
				y1.position.set(y1P.x, -pixi.renderer.height - y1.height);

				let u = 1;
				let assets = [];
				let a;
				let r;
				let r2 = 0;
				let mx = Math.floor(pixi.renderer.width / bs);
				for(; u <= bs; u++)
				{
					a = new PIXI.Sprite(res['a' + u]);
					layer.addChild(a);
					a.scale.set(.3, .3);
					if(mx > a.width)
					{
						r = Math.random() * (mx - a.width);
					}
					else
					{
						r = mx;
					}
					a.position.set(40 + r2 + r, -pixi.renderer.height - a.height);
					r2 += r;
					assets.push(a);
				}
				
				const animate = () =>
				{
					let k = 0;
					let s = performance.now();

					ease.add(b1, {x: b1P.x, y: b1P.y}, {duration: 300, ease: 'easeOutBounce'});
					ease.add(y1, {x: y1P.x, y: y1P.y}, {duration: 600, ease: 'easeOutBounce', wait: 600});

					let len = assets.length;
					while(len--)
					{
						ease.add(assets[len], {x: assets[len].x, y: Math.random() * (pixi.renderer.height - 150 - assets[len].height)}, {wait: 1500 + Math.random() * 2000, duration: 300, ease: 'easeOutBounce'});
					}

					pixi.ticker.add((delta) =>
					{
						let diff = performance.now() - s - 3500;			
						if(diff < 0) return;

						k++;
						let len = assets.length;
						while(len--)
						{
							assets[len].position.set(assets[len].x, Math.sin((k + len * 20) * .05) * 1 + assets[len].y);
						}
					});
				};

				const viewport = document.getElementsByClassName('view-port')[0];
				if(viewport)
				{
					if(viewport.classList.contains('is-animating'))
					{
						let wrapper = () =>
						{
							viewport.removeEventListener('transitionend', wrapper);
							animate();
						};
						viewport.addEventListener('transitionend', wrapper);
					}
					else
					{
						animate();
					}
				}
			}
		});

		const onHide = ({page}) =>
		{
			if(page.id === 'home' && pixi.ticker)
			{
				pixi.ticker.stop();
			}
		};
		const onShow = ({action, page}) =>
		{
			if(action !== 'jump' && page.id === 'home' && pixi.ticker)
			{
				pixi.ticker.start();
			}
		};

		emitter.on('hide', onHide);
		emitter.on('show', onShow);

		return () =>
		{
			// pixi.view.parentNode.removeChild(pixi.view);
			pixi.destroy(true);
			emitter.off('hide', onHide);
			emitter.off('show', onShow);
		};

	}, [emitter]);
*/

	return (
		<div className="columns">
			<div className="column is-5">
				<div className="block t-heading">
					<h2 className="title is-2 pb-4">{h2}</h2>
					<p className="is-5">{intro}</p>
				</div>
				<div className="block has-text-centered">
					<button onClick={onClick} className="button is-primary style-btn is-size-4">
						<span>{btnText}</span>
						<i className="fa fa-chevron-right"></i>
					</button>
				</div>
			</div>
			<div className="column is-7">
				<div className="block t-illusion" ref={pixiRef}>
				{/*
					<figure className="image">
						<img className="image" src={illusion} alt="illustion" />
					</figure>
				*/}
				</div>
			</div>
		</div>
	);
}
